import { TextField } from "@/app/fields";
import type { Errors } from "@/app/useDraft";
import { Form, Switch } from "@/ui";
import type { PrefixDraft } from "./prefixDraft";

interface Props { draft: PrefixDraft; errors: Errors<PrefixDraft>; set: <K extends keyof PrefixDraft>(k: K, v: PrefixDraft[K]) => void; isNew: boolean }

/** 号码前缀表单的字段，见 docs/03 3.6。前缀是主键，编辑时不显示，改前缀等于新建一条。 */
export function PrefixForm({ draft, errors, set, isNew }: Props) {
  return (
    <Form columns={2}>
      {isNew && <TextField id="n-prefix" label="前缀" required mono value={draft.prefix} error={errors.prefix} hint="国家码加号段，例如 6281" onChange={(v) => set("prefix", v)} />}
      <TextField id="n-country" label="国家" required mono value={draft.country} error={errors.country} hint="两位代码" onChange={(v) => set("country", v.toUpperCase())} />
      <TextField id="n-mcc" label="MCC" required mono value={draft.mcc} error={errors.mcc} onChange={(v) => set("mcc", v)} />
      <TextField id="n-mnc" label="MNC" required mono value={draft.mnc} error={errors.mnc} onChange={(v) => set("mnc", v)} />
      <TextField id="n-operator" label="运营商" required value={draft.operator_name} error={errors.operator_name} onChange={(v) => set("operator_name", v)} />
      {!isNew && <Switch label="启用" checked={draft.status === "active"} onChange={(on) => set("status", on ? "active" : "disabled")} />}
    </Form>
  );
}
